import { contains } from 'ramda';

const route = [
  '$stateProvider',
  ($stateProvider) => {
    $stateProvider.state('authenticated.company.search', {
      url: '/search',
      component: 'tctCompanySearch',
      resolve: {
        hasPermission: ['actionsFactory',
          '$ngRedux',
          (actionsFactory, $ngRedux) => {
            const state = $ngRedux.getState();
            const authenticatedUser = state.authentication && state.authentication.user;

            if (!contains(authenticatedUser.type, ['editor'])) {
              $ngRedux.dispatch(actionsFactory.state('authenticated.company.detail.documents', { id: authenticatedUser.companyId }));
            }
          }],
      },
    });
  },
];

export { route as default };
